import { PublicManfrediteJobApplication } from 'interfaces/manfredite.interface';
import { config } from 'utils/config';
import * as fetch from 'utils/fetch';

const ENDPOINT_PATH = '/public/manfredite/job-application';
const API_BASE_URL = `${config.apiUrl}${ENDPOINT_PATH}`;

/**
 * Get a Job Application of a Manfredite by its slug
 *
 * @param slug - The Job Application slug
 * @param manfrediteId - ID of the currently manfredite logged ID (if logged)
 *
 * @returns the Job Application (Manfredite profile, summary info and CV Application info).
 */
async function getBySlug(
  slug: string,
  manfrediteId?: number
): Promise<PublicManfrediteJobApplication> {
  const baseUrl = API_BASE_URL;
  const params = new URLSearchParams();

  if (manfrediteId) {
    params.set('manfrediteId', manfrediteId.toString());
  }

  const res = await fetch.get<{
    data: PublicManfrediteJobApplication;
  }>(`${baseUrl}/${slug}?${params}`);
  return res.data;
}

/**
 * Accept the terms and conditions of a given Job Application slug
 *
 * @param slug - The slug of the Job application to accept the terms and conditions
 */
async function acceptTermsAndConditions(slug: string): Promise<void> {
  const baseUrl = API_BASE_URL;

  return fetch.put(`${baseUrl}/${slug}/accept-privacy-terms`, {});
}

const ManfrediteJobApplicationService = {
  getBySlug,
  acceptTermsAndConditions
};

export default ManfrediteJobApplicationService;
